import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@ng-cloud/badger-core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SupersetService extends ApiService {

  public getEmbedInfo(dashboardType: string = 'StoreOverview', appType: string = 'Portal', params?: any): Observable<any> {
    return this.http.get(this.url(`superset_dashboards/${dashboardType}/${appType}/embed_info`), { params: params ? ApiService.params(params) : {} });
  }

  public getSupersetDomain() {
    const supersetApi = _.find(ApiService.apis, { 'apiName': 'superset' });
    return supersetApi.apiBase;
  }
}
